import { Guid, Nillable } from '@web/utils';
import { BoxQuestionnaireStatus } from '../enums';
import { OrderNumber } from '../types';
import {
  PublicBoxQuestionnaireContextOperations,
  PublicBoxRecommendedQuestionnaire,
} from '../../public/models';
import { BoxQuestionnaireQuestion } from './box-questionnaire-question';

export class BoxQuestionnaireDetails {
  public constructor(
    private readonly data: {
      contextOperations: PublicBoxQuestionnaireContextOperations;
      createdAt: Date;
      endDate: Date;
      description?: Nillable<string>;
      id: Guid;
      isShown: boolean;
      logoAlt?: Nillable<string>;
      logoUrl?: Nillable<string>;
      name: string;
      orderId: Guid;
      orderNumber: OrderNumber;
      questions: BoxQuestionnaireQuestion[];
      recommendedQuestionnaires: PublicBoxRecommendedQuestionnaire[];
      status: BoxQuestionnaireStatus;
    },
  ) {}

  public get contextOperations(): PublicBoxQuestionnaireContextOperations {
    return this.data.contextOperations;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get endDate(): Date {
    return this.data.endDate;
  }

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get isShown(): boolean {
    return this.data.isShown;
  }

  public get logoAlt(): Nillable<string> {
    return this.data.logoAlt;
  }

  public get logoUrl(): Nillable<string> {
    return this.data.logoUrl;
  }

  public get name(): string {
    return this.data.name;
  }

  public get orderId(): Guid {
    return this.data.orderId;
  }

  public get orderNumber(): OrderNumber {
    return this.data.orderNumber;
  }

  public get questions(): BoxQuestionnaireQuestion[] {
    return this.data.questions;
  }

  public get recommendedQuestionnaires(): PublicBoxRecommendedQuestionnaire[] {
    return this.data.recommendedQuestionnaires;
  }

  public get status(): BoxQuestionnaireStatus {
    return this.data.status;
  }
}
